export default __webpack_public_path__ + "static/media/cardboard_study_2.f442a9a7.jpg";